<template>
  <div>
  <div v-if="!json.init" class="spe-lift" :class="{ type2: jdata.styleType == 2 }" :ddt-area="`component_${json.floorId}_电梯组件`" ddt-expose="on">
		<div class="outer" :style="commonStyle" :class="{ fixed: fixed }">
			<dl>
				<dt class="dt" v-if="jdata.tabsData.length <= 4" :style="tabStyle">
					<a
            v-for="(el, index) in jdata.tabsData"
            :key="index"
            @click="totop(index)"
            :style="{color:current==index?(jdata.tabStyle.titleActiveColor || jdata.tabStyle.titleActiveDefaultColor):''}"
            :ddt-src="el.title"
            :data-area="pt()"
            :data-pos="`component_${json.floorId}_电梯组件.坑位${index + 1}_点击`"
            :data-desc="el.title"
            :dd_name="`${pt()}.component_${json.floorId}_电梯组件.坑位${index + 1}_点击.${el.title}`"
            :ddt-click="`${pt()}.component_${json.floorId}_电梯组件.坑位${index + 1}_点击.${el.title}`"
            :ddt-pit="`坑位${index + 1}_点击`"
            ddt-expose="on"
          >
            <img v-lazy="el.image" />
						<h2>{{ el.title }}</h2>
					</a>
				</dt>
				<template v-else>
					<dt class="dt_scroll" :style="tabStyle">
						<div ref="scrollList" class="scroll-list" >
							<div v-for="(el, index) in jdata.tabsData" :key="index" :floor-id="el.floorId" class="scroll-item" ref="scrollItem" >
								<a
                  @click.stop.prevent="totop(index)"
                  :style="{color:current == index?(jdata.tabStyle.titleActiveColor || jdata.tabStyle.titleActiveDefaultColor):''}"
                  :ddt-src="el.title"
                  :data-area="pt()"
                  :data-pos="`component_${json.floorId}_电梯组件.坑位${index + 1}_点击`"
                  :data-desc="el.title"
                  :dd_name="`${pt()}.component_${json.floorId}_电梯组件.坑位${index + 1}_点击.${el.title}`"
                  :ddt-click="`${pt()}.component_${json.floorId}_电梯组件.坑位${index + 1}_点击.${el.title}`"
                  :ddt-pit="`坑位${index + 1}_点击`"
                  ddt-expose="on"
                >
									<img v-lazy="el.image" />
									<h2>{{ el.title }}</h2>
								</a>
							</div>
						</div>
						<div
              class="r"
              @click="open = !open"
              :style="tabStyle"
              :data-area="pt()"
              :data-pos="`component_${json.floorId}_电梯组件.展示控制_点击`"
              data-desc="展开"
              :dd_name="`${pt()}.component_${json.floorId}_电梯组件.展示控制_点击.展开`"
              :ddt-clicke="`${pt()}.component_${json.floorId}_电梯组件.展示控制_点击.展开`"
              ddt-pit="展示控制_点击"
              ddt-src="展开"
              ddt-expose="on"
            >
							<i class="iconfont">&#xe666;</i>
						</div>
					</dt>

					<dt class="dt_scroll_open" v-show="open">
						<div class="title" :style="tabStyle">
							<div class="l">选择楼层</div>
							<div
                class="r"
                @click="open = !open"
                :style="tabStyle"
                :data-area="pt()"
                :data-pos="`component_${json.floorId}_电梯组件.展示控制_点击`"
                data-desc="收起"
                :dd_name="`${pt()}.component_${json.floorId}_电梯组件.展示控制_点击.收起`"
                :ddt-click="`${pt()}.component_${json.floorId}_电梯组件.展示控制_点击.收起`"
                ddt-pit="展示控制_点击"
                ddt-src="收起"
                ddt-expose="on"
              >
								<i class="iconfont">&#xe665;</i>
							</div>
						</div>
						<div class="list">
							<a
                v-for="(el, index) in jdata.tabsData"
                :key="index"
                @click.stop.prevent="totop(index, false)"
                :style="{color:current==index?(jdata.tabStyle.titleActiveColor || jdata.tabStyle.titleActiveDefaultColor):''}"
                :ddt-src="el.title"
                :data-area="pt()"
                :data-pos="`component_${json.floorId}_电梯组件.坑位${index + 1}_点击`"
                :data-desc="el.title"
                :dd_name="`${pt()}.component_${json.floorId}_电梯组件.坑位${index + 1}_点击.${el.title}`"
                :ddt-click="`${pt()}.component_${json.floorId}_电梯组件.坑位${index + 1}_点击.${el.title}`"
                :ddt-pit="`坑位${index + 1}_点击`"
                ddt-expose="on"
              >
								<h2>{{ el.title }}</h2>
							</a>
						</div>
					</dt>
				</template>
			</dl>
		</div>
	</div>
  <div v-else :style="{height:`${json.height}px`}"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import style (>= Swiper 6.x)
import "swiper/css/swiper.css";

export default {
	name: "SpeStairs",
	props: {
		json: {
			type: Object,
			default: () => {
				return {};
			}
		},
		pagebgcolor: ""
	},
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {
			swiperOptions: {
				slidesPerView: 4,
				loop: false
				// Some Swiper option/callback...
			},
			top: 0,
			fixed: false, //是否固定
			open: false, //tabs 是否打开
			current: -1, //当前选中的楼梯
      canScroll:true
		};
	},
  inject: ['pt'],
	computed: {
		jdata() {
			return this.json.data || { commonStyle: {}, tabStyle: {}, tabsData: [] };
		},
		swiper() {
			return this.$refs.mySwiper.$swiper;
		},
		commonStyle() {
			let sty = {
				// padding: "0 " + (this.open ? 0 : this.jdata.commonStyle.margin) + "px",
				padding: "0 " + this.jdata.commonStyle.margin + "px",
				top: this.top + "px"
			};
      if (this.jdata.commonStyle.backgroundType == 2) {
        //背景图
        sty.backgroundImage = `url(${this.jdata.commonStyle.backgroundImage})`;
        sty.backgroundColor = this.pagebgcolor || '#f7f7f7'
      } else if(this.jdata.commonStyle.backgroundType == 1){
        if (this.jdata.commonStyle.usePageBackgroundColor) {
          sty.backgroundColor =this.jdata.commonStyle.bgColor
        }else{
          sty.backgroundColor = this.jdata.commonStyle.backgroundColor;
        }
      }
			return sty;
		},
		tabStyle() {
			let sty = {
				color: this.jdata.tabStyle.titleColor || this.jdata.tabStyle.titleDefaultColor,
				backgroundColor: this.jdata.tabStyle.backgroundColor || this.jdata.tabStyle.backgroundDefaultColor || "#fff"
			};

			return sty;
		}
	},
	watch: {
    current(newVal){
      if(typeof newVal == 'number')  this.current = newVal;

    },
  },
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
    // this.handleScroll();
	},
	methods: {
		handleScroll() {
			//滚动条 滚动的距离
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop,"滚起来")

      let divs = document.querySelectorAll(".com>div");



      //获得search和lift组件的位置 然后来决定fixed的时候的位置
			let spesearch = document.querySelector(".spe-search");
			let search_index = (spesearch && spesearch.parentNode.getAttribute("data-index")) || -1;
			let spelift = document.querySelector(".spe-lift");
			let lift_index = (spelift && spelift.parentNode.parentNode.getAttribute("data-index")) || -1;
  
      if (!spelift) return

			//楼梯组件在页面的位置
			let offsetTop = spelift.offsetTop;
			let top = 0; //吸顶距离顶部的高度
      let searchH = 0
      let liftH = 0
			//获得头部高度
			if (document.querySelector(".header_container.fixed")) {
				let h = document.querySelector(".ddheader").offsetHeight || 0;
				//滚动的位置 要减去 头部ddheader 高度
				offsetTop = offsetTop - h;
				top += h;
			}
			// console.log('lift_index:',lift_index,search_index)
			//获得楼梯组件高度
			if (lift_index > search_index && document.querySelector(".spe-search .fixed")) {
				let h = document.querySelector(".spe-search .fixed").offsetHeight || 0;
        searchH = h
				//滚动的位置 要减去 头部ddheader 高度
				offsetTop = offsetTop - h;
				top += h;
			}
			this.top = top;
			if (scrollTop >= offsetTop) {
				this.fixed = true;
			} else {
				this.fixed = false;
			}
      liftH = (document.querySelector(".spe-lift") && document.querySelector(".spe-lift").offsetHeight) || 0;
      // 遍历电梯楼层  楼层高度和滚动条高度做比较
      // console.log(this.jdata.tabsData)
      for (let i = 0, len = this.jdata.tabsData.length; i < len; i++) {
        const div = document.querySelector(`#id${this.jdata.tabsData[i].floorId}`) // 楼层对象
        if (!div) continue
        const divH = (div && div.offsetHeight) || 0 // 楼层高度
        // const windowH = window.screen.availHeight // 屏幕高度
        const topLine = scrollTop + top + liftH // 显示区顶部边界
        if (div.offsetTop <= topLine && div.offsetTop + divH > topLine) {
          if(this.canScroll){
            if(i != this.current){
              this.clickScroll(i)
            }
            this.current = i
          }
          break
        }
        // 如果没有电梯楼层显示，则去掉电梯楼层的选中状态
        if (i === len - 1 && this.canScroll) {
          // 最后一个时
          this.current = -1
        }
      }
		},

		/**
		 * 点击跳到对应的楼层
		 */
		totop(index, animate = true) {
		  this.canScroll = false
      setTimeout(()=>{
        this.canScroll = true
      },400)
      this.$set(this,'current',index)
			let floorId = this.jdata.tabsData[index].floorId;
			//获得楼层位置

			let div = document.querySelector("#id" + floorId);
			if (div) {
				let offsetTop = div.offsetTop;
				//获得头部高度
				if (document.querySelector(".header_container.fixed")) {
					let h = document.querySelector(".ddheader").offsetHeight || 0;
					//滚动的位置 要减去 头部ddheader 高度
					offsetTop = offsetTop - h;
				}
				//获得 楼梯高度
				if (document.querySelector(".spe-lift")) {
					let h = document.querySelector(".spe-lift").offsetHeight || 0;
					//滚动的位置 要减去 楼梯高度
					offsetTop = offsetTop - h;
				}
				//获得 搜索高度
				if (document.querySelector(".spe-search>.fixed")) {
					let h = document.querySelector(".spe-search").offsetHeight || 0;
					//滚动的位置 要减去 楼梯高度
					offsetTop = offsetTop - h;
				}
				// console.log("获得头部高度", document.querySelector(".ddheader.fixed"));

				window.scrollTo(0, offsetTop);
        this.clickScroll(index, animate)
			}
			this.open = false;
		},
    clickScroll(index, animate = true){
      if (!this.$refs.scrollList) return
      let dScrollLeft = this.$refs.scrollList.scrollLeft
      let targetLeft = this.$refs.scrollItem[index].offsetLeft + (this.$refs.scrollItem[index].offsetWidth - window.innerWidth) / 2 // 屏幕宽度;
      // this.$refs.dauItemBox.scrollLeft = targetLeft
      if (dScrollLeft < targetLeft) {
        if (animate) {
          const timeTop = setInterval(() => {
            dScrollLeft += 10
            this.$refs.scrollList.scrollLeft = dScrollLeft
            if (dScrollLeft >= targetLeft) {
              clearInterval(timeTop)
            }
          }, 10)
        } else {
          this.$refs.scrollList.scrollLeft = targetLeft
        }
      }
      if (dScrollLeft > targetLeft) {
        if (animate) {
          const timeTop1 = setInterval(() => {
            dScrollLeft -= 10
            this.$refs.scrollList.scrollLeft = dScrollLeft
            if (dScrollLeft <= targetLeft) {
              clearInterval(timeTop1)
            }
          }, 10)
        } else {
          this.$refs.scrollList.scrollLeft = targetLeft
        }
      }
    }
	},
	filters: {
		label_filter(v) {
			if (v == "当当自营") {
				return "自营";
			}
			return v;
		}
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.spe-lift {
	min-height: 88px;
	.outer {
		width: 100%;
		box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100%;
		dl {
			width: 100%;
			color: #141414;
			font-size: 26px;
			background-size: cover;
      position: relative;
			.dt {
				display: flex;
				padding: 12px 0;
				box-sizing: border-box;
				min-height: 88px;
				a {
					flex: 1;
					display: flex;
					align-items: center;
					justify-content: center;
					img {
						width: 80px;
						height: 80px;
						display: none;
					}
				}
			}
			.dt_scroll {
				position: relative;
				padding: 12px 0;
				box-sizing: border-box;
				min-height: 88px;
        .scroll-list{
          display: flex;
          flex-direction: row;
          align-items: center;
          overflow-x: auto;
          &::-webkit-scrollbar{width:0px;height:0px;}
          .scroll-item{
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 64px;
            width: 31%;
            flex-shrink: 0;
            &:last-child {
              padding-right: 33px;
            }
            a {
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 80px;
                height: 80px;
                display: none;
              }
            }
          }
        }
				.swiper-slide {
					display: flex;
					align-items: center;
					justify-content: center;
					min-height: 64px;
					a {
						display: flex;
						align-items: center;
						justify-content: center;
						img {
							width: 80px;
							height: 80px;
							display: none;
						}
					}
				}
				.r {
					width: 66px;
					background: #fff;
					box-shadow: -12px 0px 10px -10px #999;
					position: absolute;
					top: 0;
					right: 0;
					bottom: 0;
					z-index: 1;
					display: flex;
					align-items: center;
					justify-content: center;
					i {
						font-size: 30px;
						color: #828282;
					}
				}
			}
			.dt_scroll_open {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-color: #fff;
        z-index: 2;
				.title {
					display: flex;
					align-items: center;
					padding: 0 24px;
					position: relative;
					height: 88px;
					.l {
						flex: 1;
						font-size: 26px;
						color: #828282;
					}
					.r {
						width: 66px;
						background: #fff;
						box-shadow: -12px 0px 10px -10px #999;
						position: absolute;
						top: 0;
						right: 0;
						bottom: 0;
						z-index: 1;
						display: flex;
						align-items: center;
						justify-content: center;
						i {
							font-size: 30px;
							color: #828282;
						}
					}
				}
				.list {
					display: flex;
					flex-wrap: wrap;
					margin-top: 20px;
					a {
						margin-bottom: 30px;
						width: 25%;
						text-align: center;
						img {
							width: 80px;
							height: 80px;
							display: none;
						}
					}
				}
			}
			.on {
				color: #ff463c;
			}
		}
	}
	.fixed {
		position: fixed;
		left: auto;
		right: auto;
		top: 89px;
		z-index: 10;
	}
}
.type2 {
	min-height: 140px;
	.outer {
		dl {
			.dt {
				a {
					flex-direction: column;
					img {
						display: block !important;
					}
				}
			}
			.dt_scroll {
				.scroll-item {
					a {
						flex-direction: column;
						img {
							display: block !important;
						}
					}
				}
			}
		}
	}
}
</style>
